import { Modal } from "react-bootstrap";

interface ErrorModalProps {
    show: boolean;
    onClose: () => void;
    errors: string[];
}

const ErrorModal: React.FC<ErrorModalProps> = ({ show, onClose, errors }) => {
    return (
        <Modal show={show} onHide={onClose} centered size="sm">
            <Modal.Header closeButton>
                <Modal.Title>Failed to Add Voucher Codes</Modal.Title>
            </Modal.Header>
            <Modal.Body
                style={{
                    maxHeight: "300px",   
                    overflowY: "auto",     
                    paddingRight: "10px",  
                }}
            >
                {errors.length > 0 ? (
                    <ul className="mb-0">
                        {errors.map((err, index) => (
                            <li key={index} className="text-danger">
                                {err}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No error details available.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn add-btn" onClick={onClose}>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ErrorModal;

